import React, { createContext, useContext, useState, ReactNode } from 'react';

interface MilestoneContextType {
  currentStep: number;
  setCurrentStep: (step: number) => void;
}

const MilestoneContext = createContext<MilestoneContextType | undefined>(undefined);

export const useMilestone = () => {
  const context = useContext(MilestoneContext);
  if (context === undefined) {
    throw new Error('useMilestone must be used within a MilestoneProvider');
  }
  return context;
};

interface MilestoneProviderProps {
  children: ReactNode;
}

export const MilestoneProvider: React.FC<MilestoneProviderProps> = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(1);

  return (
    <MilestoneContext.Provider value={{ currentStep, setCurrentStep }}>
      {children}
    </MilestoneContext.Provider>
  );
};